import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { NavbarPilotos } from "../componentes/navbarPilotos";
import { InputCustom } from "../componentes/inputComponent";
import { Form, Space, Row, Col, Button, Card } from "antd";

export const ResetearContraseña = ({ setAlerta }) => {
  const manejarAlertas = (tipo, mensaje) => {
    // Usar setAlerta para mostrar la alerta
    setAlerta({ message: mensaje, type: tipo });
  };
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    newPassword: "",
  })
  const [confirmPassword, setConfirmPassword] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [loading, setLoading] = useState(false);
  const token = searchParams.get("token");

  const handleSubmit = async () => {
    if (formData.newPassword !== confirmPassword) {
      manejarAlertas("error", "Las contraseñas no coinciden.");
      return;
    }

    try {
      setLoading(true);
      // console.log("lo que se envía", token, formData)
      const response = await axios.post(`${process.env.REACT_APP_DOMINIO}/piloto/restablecer-password`, {
        token,
        newPassword: formData.newPassword,
      });
      manejarAlertas("success", response.data.message || "Contraseña restablecida correctamente.");
      setFormData({ newPassword: "" });
      setConfirmPassword("");
      navigate(`/`)
    } catch (error) {
      manejarAlertas("error", error.response?.data?.message || "Error al restablecer la contraseña");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return (
    <>
      <NavbarPilotos/>
      <section
        id="seccionPiloto"
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          marginTop: "1em",
        }}
      >
        <h1 className="titulos">Resetear contraseña</h1>
      </section>

      <section
        style={{
          display: "flex",
          flexDirection: "column",
          flexWrap: "wrap",
          justifyContent: "center",
          alignItems: "center",
          gap: "10px",
          marginTop: "20px"
        }}
      >
        <div
          className="contendor-card-carreras"
          style={{
            width: "auto",
            width: "800px",
            padding: "20px",
            border: "1px solid #bbbbbb",
            borderRadius: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "10px",
            }}
          >
            <h1 className="titulos-secundarios">Restablecer Contraseña</h1>
          </div>
          <hr></hr>
          <Form layout="vertical" onFinish={handleSubmit}>
            <Row className="rowAdmin" gutter={16} align="center">
                <Col xs={24} sm={12} style={{ width: "100%" }}>
                  <Form.Item>
                    <InputCustom 
                      idCampo="newPassword"
                      nombreCampo="Nueva contraseña"
                      elPlaceholder="Inserte su nueva contraseña"
                      elValue={formData.newPassword}
                      onChange={handleChange}
                      required
                      tipo="password"
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} style={{ width: "100%" }}>
                  <Form.Item>
                    <InputCustom 
                      idCampo="confirmPassword"
                      nombreCampo="Confirmar contraseña"
                      elPlaceholder="Inserte otra vez su contraseña"
                      elValue={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      required
                      tipo="password"
                    />
                  </Form.Item>
                </Col>
            </Row>
            <Row justify="center" style={{ marginTop: "1em" }}>
                <Col xs={24} sm={24} className="botonesResponsive"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                  textAlign: "center"
                }}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    className="boton-principal-reset"
                  >
                    {loading ? "Cambiando..." : "Cambiar Contraseña"}
                  </Button>
                </Col>
              {mensaje && <p>{mensaje}</p>}
              </Row>
          </Form>
        </div>
      </section>
    </>
  );
}